export const AUTH_TOKEN_CHECK = "AUTH_TOKEN_CHECK";
export const REQUEST_TOKEN_CHECK = "REQUEST_TOKEN_CHECK";
export const RESET_TOKEN = "RESET_TOKEN";